import { render, staticRenderFns } from "./switcher-item.vue?vue&type=template&id=35ea1116&lang=pug&"
import script from "./switcher-item.vue?vue&type=script&lang=js&"
export * from "./switcher-item.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports